export default "__VITE_ASSET__CcaLmL2U__"